export default __webpack_public_path__ + "static/media/company.fcd769d4.svg";